/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SwitchCompanyResponseDto } from '../models/SwitchCompanyResponseDto';
import type { SwitchConfigurationDto } from '../models/SwitchConfigurationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SwitchConfigurationService {

    /**
     * @param userId
     * @returns SwitchConfigurationDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiUserSwitchConfiguration(
        userId: string,
    ): CancelablePromise<SwitchConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/user/{userId}/switch-configuration',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param destinationCompanyId
     * @returns SwitchCompanyResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiUserSwitchableRoles(
        destinationCompanyId?: string,
    ): CancelablePromise<Array<SwitchCompanyResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/user/switchable-roles',
            query: {
                'destinationCompanyId': destinationCompanyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param forceUseSwitchContext
     * @param requestBody
     * @returns SwitchCompanyResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiUserSwitchableCompanies(
        forceUseSwitchContext: boolean = false,
        requestBody?: Array<string>,
    ): CancelablePromise<Array<SwitchCompanyResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/user/switchable-companies',
            query: {
                'forceUseSwitchContext': forceUseSwitchContext,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns SwitchCompanyResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiUserSwitchableCompaniesForSwitchPage(): CancelablePromise<Array<SwitchCompanyResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/user/switchable-companies-for-switch-page',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns SwitchCompanyResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiUserSwitchableCompaniesForUserSettingPage(): CancelablePromise<Array<SwitchCompanyResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/user/switchable-companies-for-user-setting-page',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
